import { useEffect, useState } from "react"

interface Countdown {
    dias: string
    horas: string
    minutos: string
    segundos: string
}

export function useCountdown(dataFim: string | null): Countdown {
    const [tempoRestante, setTempoRestante] = useState<Countdown>({
        dias: "00",
        horas: "00",
        minutos: "00",
        segundos: "00",
    })

    useEffect(() => {
        if (!dataFim) return

        const fim = new Date(dataFim)

        const atualizarContador = () => {
            const agora = new Date()
            const diff = fim.getTime() - agora.getTime()

            if (diff <= 0) {
                setTempoRestante({ dias: "00", horas: "00", minutos: "00", segundos: "00" })
                return
            }

            const dias = Math.floor(diff / (1000 * 60 * 60 * 24))
            const horas = Math.floor((diff / (1000 * 60 * 60)) % 24)
            const minutos = Math.floor((diff / (1000 * 60)) % 60)
            const segundos = Math.floor((diff / 1000) % 60)

            setTempoRestante({
                dias: String(dias).padStart(2, "0"),
                horas: String(horas).padStart(2, "0"),
                minutos: String(minutos).padStart(2, "0"),
                segundos: String(segundos).padStart(2, "0"),
            })
        }

        const interval = setInterval(atualizarContador, 1000)
        atualizarContador()

        return () => clearInterval(interval)
    }, [dataFim])

    return tempoRestante
}
